import React from "react"
import Row from "react-bootstrap/Row"

import styles from "./LayoutRow.module.scss"

const LayoutRow = ({ fullWidth, children }) => {
  return (
    <section className={`${styles.element} ${!fullWidth ? styles.capped : ""}`}>
      <Row className="row-large-gutters">{children}</Row>
    </section>
  )
}

export default LayoutRow
